var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.queryParam)?_c('div',{staticClass:"search-results"},[_vm._v(" Results for "),_c('b',[_vm._v(_vm._s(_vm.queryParam))]),_c('a',{staticClass:"clear",on:{"click":_vm.clear}},[_vm._v("Clear")])]):_vm._e(),_c('product-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }